import { render, staticRenderFns } from "./documentContent.vue?vue&type=template&id=3f3f1c5a&scoped=true&"
import script from "./documentContent.vue?vue&type=script&lang=js&"
export * from "./documentContent.vue?vue&type=script&lang=js&"
import style0 from "./documentContent.vue?vue&type=style&index=0&id=3f3f1c5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3f1c5a",
  null
  
)

export default component.exports